import React from 'react';
import { connect } from "react-redux";
import StarRatings from 'react-star-ratings';
import { updateData } from "../actions";
const _ = require("lodash");

const mapStateToProps = state => ({
    data: state.formDataReducer,
    filterdata: state.formDataReducer.filterdata,
    editformdata: state.formDataReducer.editformdata,
    hasErrored: state.formDataReducer.hasErrored,
    isLoading: state.formDataReducer.isLoading,
    token: state.formLoginReducer.token,
});
function bindAction(dispatch) {
    return {
        update: (key, value, storekey) => dispatch(updateData(key, value, storekey))
    };
}

class RatingUI extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = { Noofstars: [], data: {} };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        var data = nextProps.data[nextProps.formid] ? nextProps.data[nextProps.formid] : null;
        if (JSON.stringify(data) != JSON.stringify(prevState.data)) {
            return {
                data: data
            }
        } else return null;
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.data != prevState.data && this.props.control.ratingdata.length > 0) {
            this.calculateScore();
        }
    }
    componentDidMount() {
        var Noofstars = []
        
        if (this.props.control.customstarvalues) {
            Noofstars = this.props.control.customstarvalues.split(',');
        } else {
            Noofstars = _.range(this.props.control.Noofstar);
        }
        this.setState({ Noofstars: Noofstars });
    }
    calculateScore() {
        const { control, formid } = this.props;
        var data = this.state.data;

        var finalScore = 0;
        control.ratingdata.forEach(item => {
            const val = !isNaN(data[item.key]) ? data[item.key] : 0;
            finalScore = finalScore + ((item.weightage / 100) * val)
        })
        this.props.update(control.key, finalScore.toFixed(1), formid);
    }
    updateOverAll(rate) {

    }
    isFloat(num) {
        return !isNaN(num) && num % 1 !== 0;
    }
    update(key, value, formid) {
        
        this.props.update(key, value, formid);
    }
    render() {

        const { control, formid } = this.props;
        var data = this.state.data;

        return (
            <React.Fragment>
                {control.label &&
                    <label htmlFor={control.id} style={{ position: 'absolute' }}>
                        {control.label}
                        {control.require &&
                            <sup className="text-danger font-weight-bold">*</sup>
                        }
                        {control.showhelptext &&
                            <span className={"custom-tooltip"}>
                                <i className={"fa fa-question-circle ml-2 help-text"}></i>
                                <span className={"tooltip tooltip-" + control.helpdirection}>{control.help}</span>
                            </span>
                        }
                    </label>
                }
                {control.ShowOverallScore || control.readonly ?
                    <fieldset id={control.id} className="rating-custom pt-3">
                        <StarRatings
                            rating={isNaN(data[control.key]) || !data[control.key] ? 0 : parseFloat(data[control.key])}
                            starRatedColor="rgb(255, 215, 0)"
                            starEmptyColor="rgb(221, 221, 221)"
                            numberOfStars={control.Noofstar ? parseInt(control.Noofstar) : 5}
                            name={control.key}
                            starDimension={control.fontsize ? control.fontsize : "40px"}
                        />
                    </fieldset>
                    :
                    <fieldset id={control.id} className="rating-custom pt-2">
                        {this.state.Noofstars.map(num => {
                            return (
                                <React.Fragment>
                                    <input type="radio" id={control.id + num} name={control.id} onClick={() => data[control.key] === num ? this.update(control.key, "0", formid) : this.update(control.key, num, formid)}
                                        aria-label="Rating" value={num} checked={num <= data[control.key]} />
                                    <label className={(this.isFloat(num) ? 'half' : 'full') + ' ' + (num <= data[control.key] && 'fill')}
                                        style={{ 'fontSize': (control.fontsize ? control.fontsize : '1.95em') }} title={num} htmlFor={control.id + num}></label>
                                </React.Fragment>
                            )
                        })
                        }
                    </fieldset>
                }
            </React.Fragment>

        );
    }
}


export default connect(mapStateToProps, bindAction)(RatingUI);